const API_BASE_URL = process.env.REACT_APP_API_URL || 'https://apisimilariz.vercel.app/api';
const WEBSITE_SLUG = process.env.REACT_APP_WEBSITE_SLUG || 'citematch';

const apiConfig = {
  BASE_URL: API_BASE_URL,
  WEBSITE_SLUG,
};

export default apiConfig;

